exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "iframe{border:1px solid #d2d6de}", "", {"version":3,"sources":["D:/laragon/www/sima/simaapp-web/src/components/views/proyectos/Iframe.vue"],"names":[],"mappings":"AACA,OACE,wBAA0B,CAC3B","file":"Iframe.vue","sourcesContent":["\niframe {\r\n  border: 1px solid #d2d6de;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7264ccf2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/proyectos/Iframe.vue
// module id = 372
// module chunks = 5